import { APP_MODULES, type AppModuleKey } from '@/config/modules';
import { meetsRequirements } from '@/lib/permissions';
import { type SessionUser } from '@/stores/session';

// Módulos con tarjeta de acción en el dashboard, en el orden en que se
// muestran. Cada tarjeta linkea a la pantalla de su módulo.
export const DASHBOARD_CARD_MODULES = [
  'products',
  'pending',
  'aiSuggestions',
] as const satisfies readonly AppModuleKey[];

export type DashboardCardModule = (typeof DASHBOARD_CARD_MODULES)[number];

// Tarjetas que el user puede abrir. Gate por MÓDULO, no por el permiso de su
// dato: cada tarjeta linkea a una pantalla, y si el user no cumple todo lo que
// ese módulo pide el guard lo manda a /forbidden. Mismo criterio que
// `useMeetsRequirements`: sin user, ninguna; `permissions` undefined (sesión
// sin `/auth/me`) abre todas.
//
// Lo leen el dashboard (qué tarjetas pinta) y `useHomeTarget` (sin ninguna,
// Inicio se oculta y `/` va a la primera sección).
export function visibleDashboardCards(
  user: Pick<SessionUser, 'permissions'> | null,
): DashboardCardModule[] {
  if (!user) return [];
  return DASHBOARD_CARD_MODULES.filter((module) =>
    meetsRequirements(user.permissions, APP_MODULES[module].requires),
  );
}
